// File: src/store/store.js
// Purpose: Redux store configuration using Redux Toolkit
// Last modified: 2025-11-06

import { configureStore } from '@reduxjs/toolkit';
import packagesReducer from './slices/packagesSlice';
import userReducer from './slices/userSlice';
import savedQuestionsReducer from './slices/savedQuestionsSlice';
import searchReducer from './slices/searchSlice';
import settingsReducer from './slices/settingsSlice';

/**
 * Redux store configuration with Redux Toolkit
 *
 * Benefits over legacy setup:
 * - Less boilerplate
 * - Better TypeScript support
 * - DevTools enabled by default
 * - Redux Thunk included by default
 * - Immutable state updates with Immer
 */
const store = configureStore({
    reducer: {
        packages: packagesReducer,
        user: userReducer,
        savedQuestions: savedQuestionsReducer,
        search: searchReducer,
        settings: settingsReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types for serializable check
                ignoredActions: ['packages/fetchById/fulfilled'],
            },
        }),
    devTools: process.env.NODE_ENV !== 'production',
});

export default store;

// Export types for TypeScript support (if needed in future)
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
